export const install = (trackingId, setOptions, configOptions) => {
  const scriptId = 'ga-gtag';
  const scriptGTMId = 'ga-gtm';

  if (document.getElementById(scriptId) || document.getElementById(scriptGTMId)) {
    return;
  }

  // eslint-disable-next-line no-undef
  if (global_params['tracker_destination'] == 'r123') {
    const {head} = document;
    const script = document.createElement('script');
    script.id = scriptGTMId;

    script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${trackingId}');`;

    head.insertBefore(script, head.firstChild);

    let body_first = document.body.firstChild;
    let gtm_noscript = document.createElement('noscript');
    gtm_noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${trackingId}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    body_first.parentNode.insertBefore(gtm_noscript, body_first);
    document.body.appendChild(gtm_noscript);

    return;
  }

  const {head} = document;
  const script = document.createElement('script');
  script.id = scriptId;
  script.type = 'text/javascript';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  head.insertBefore(script, head.firstChild);

  window.dataLayer = window.dataLayer || [];

  gtag('js', new Date());

  if (typeof setOptions !== 'undefined' && setOptions !== null) {
    gtag('set', setOptions);
  }

  if (typeof configOptions !== 'undefined' && configOptions !== null) {
    gtag('config', trackingId, configOptions);
  } else {
    gtag('config', trackingId);
  }
};

export const gtag = function() {
  // Can't use arrow func + destructuring as Google expects
  // arguments objects in dataLayer (not an array of arguments).
  window.dataLayer.push(arguments);
};

export default gtag;

export const gtm_push = (params) => {
  // eslint-disable-next-line no-undef
  dataLayer.push(params);
};



// WEBPACK FOOTER //
// ./scripts/tracker/gtag.js